import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
// 登录验证
export default new Vuex.Store({
    state: {
        user: false,
        //分页子组件参数
        articlePageparm: {},
        unUsedCodePageparm: {},
        usedCodePageparm: {},
        orderPageparm: {}
    },
    mutations: {
        // 登录
        login(state, user) {
            state.user = user;
            localStorage.setItem("userInfo", user);
        },
        // 退出
        logout(state, user) {
            state.user = "";
            localStorage.setItem("userInfo", "");
        },
        setArticlePageparm(state, parm){
            state.articlePageparm = parm
        },
        setUnUsedCodePageparm(state, parm){
            state.unUsedCodePageparm = parm
        },
        setUsedCodePageparm(state, parm){
            state.usedCodePageparm = parm
        },
        setOrderPageparm(state, parm){
            state.orderPageparm = parm
        }
    }
})


// WEBPACK FOOTER //
// ./src/vuex/store.js